import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const EnquiryConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { tour, fullName } = location.state || {};

  if (!tour || !fullName) {
    // If no state, redirect immediately
    navigate("/");
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 p-6">
      <div className="bg-white shadow-md rounded-md max-w-md w-full p-8 text-center">
        <h1 className="text-2xl font-bold mb-4">Thank You, {fullName}!</h1>
        <p className="mb-6 text-lg">
          Your enquiry for the package{" "}
          <span className="font-semibold">{tour.title}</span> has been received.
        </p>
        <p className="mb-6 text-gray-700">
          Our sales team will reach out to you as soon as possible to assist
          with your memorable holiday plans.
        </p>
        <p className="mb-6 text-sm text-gray-500 italic">
          Please click the button below to return to the home page.
        </p>
        <button
          onClick={() => navigate("/")}
          className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition"
        >
          Go to Home Now
        </button>
      </div>
    </div>
  );
};

export default EnquiryConfirmation;